import * as yup from 'yup';

import { StudentSelection } from '../models';

export const studentModuleSelectionSchema = t => ({
  id: yup.number(),
  desiredNumberOfModules: yup.number().required(),
  modulePreferences: yup
    .array()
    .min(1)
    .of(
      yup.object().shape({
        rank: yup.number().required(),
        moduleId: yup.number().required()
      })
    )
});

export const studentModuleSelectionInitialValues = (
  selection: StudentSelection | undefined,
  maxSelectableModules: number
): any =>
  selection
    ? {
        id: parseInt(selection.id, 10),
        desiredNumberOfModules: selection.desiredNumberOfModules,
        modulePreferences: selection.modulePreferences?.map(p => ({
          rank: p.rank,
          moduleId: p.moduleId
        }))
      }
    : { id: undefined, desiredNumberOfModules: maxSelectableModules, modulePreferences: [] };
